import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { ErreurApi } from "./api/client";
import { theme } from "./theme";

const cache = new QueryClient({
  defaultOptions: {
    queries: {
      // Réessayer un 401 ou un 403 est inutile : la réponse ne changera pas
      // tant que l'utilisateur n'aura pas ouvert une nouvelle session. Un 429
      // non plus : insister est précisément ce que le limiteur punit.
      retry: (tentatives, erreur) => {
        if (erreur instanceof ErreurApi && erreur.statut < 500) return false;
        return tentatives < 2;
      },
      staleTime: 30_000,
    },
    mutations: { retry: false },
  },
});

const racine = document.getElementById("racine");
if (!racine) throw new Error("Élément racine introuvable dans index.html");

createRoot(racine).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      {/* Réinitialise les styles du navigateur et applique la police du thème. */}
      <CssBaseline />
      <QueryClientProvider client={cache}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
